import {ReflexiveRestModel} from 'src/lib/reflexive-model/reflexive-rest-model';
import {FieldType} from 'src/lib/reflexive-model/field-type.enum';
import {AbstractControl, FormGroup, Validators} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {unsignedIntegerValidator} from '../../../lib/validator/unsigned-integer.validator';

export class UnitLogModel extends ReflexiveRestModel {
  public static readonly UNIT_LOG_TYPE_NOTIFICATION = 'notification';
  constructor(
    private http: HttpClient
  ) {
    super();
    this.fields = {
      id: {
        type: FieldType.HiddenField,
        label: 'id',
        value: null,
      },
      message: {
        type: FieldType.StringField,
        label: 'Name',
        value: null,
        validators: [],
      },
      type: {
        type: FieldType.StringField,
        label: 'Type',
        value: null,
        validators: [Validators.required],
      },
      unit_id: {
        type: FieldType.TypeaheadField,
        label: 'Unit',
        value: null,
        isVisible: () => true,
        typeahead: {
          modelName: 'unit',
          keyField: 'id',
          displayedField: 'name',
          fields: 'id,name,project_custom_name',
          searchModelName: 'UnitSearch',
          groupBy: 'project_custom_name',
        },
      },
    };
  }
}

